export default __webpack_public_path__ + "static/media/p3.32776a98.png";